(() => {
  'use strict';

  if (window.__ndrCartIntegrityV1) return;
  window.__ndrCartIntegrityV1 = true;

  const selector = '.ndr-treino-collection .ndr-treino-card__quick-add button[data-ndr-variant-id][type="submit"]';

  const harden = (scope = document) => {
    const buttons = [];

    if (scope instanceof Element && scope.matches(selector)) buttons.push(scope);
    if (scope instanceof Document || scope instanceof Element) buttons.push(...scope.querySelectorAll(selector));

    buttons.forEach((button) => {
      button.type = 'button';
    });
  };

  const start = () => {
    harden(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) harden(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => harden(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
